import { createFileRoute } from "@tanstack/react-router";
import { getUserListColors } from "~/components/userListColors";
import { footprintListInfiniteQueryOptions } from "~/features/footprint/api";
import { FootprintTemplate } from "~/features/footprint/FootprintTemplate";

// MyProfileTemplate（layout）の上に全画面オーバーレイで重ねる
const FootprintPage = () => (
  <div className={`fixed inset-0 z-40 ${getUserListColors().overlayBg}`}>
    <FootprintTemplate />
  </div>
);

export const Route = createFileRoute("/_authenticated/my-page/footprint")({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureInfiniteQueryData(footprintListInfiniteQueryOptions),
  component: FootprintPage,
});
